module.exports = __webpack_public_path__ + "static/media/Header1.92959f8c.jpg";